import { Navigate, useLocation } from 'react-router-dom'
import RouteSuspenseFallback from '@/components/RouteSuspenseFallback'
import { getAccessToken, setAccessToken } from '@/config/api/authStore'
import { isAuthEnforced } from '@/config/api/env'
import { isWhoamiAuthenticated, useWhoami } from '@/hooks/useWhoami'
import PATHS from '@/routes/paths'

/**
 * @param {{ children: import('react').ReactNode }} props
 */
export default function RequireAuth({ children }) {
  const location = useLocation()
  const whoami = useWhoami()

  if (!isAuthEnforced()) {
    return children
  }

  if (whoami.isEnabled && whoami.isLoading) {
    return <RouteSuspenseFallback />
  }

  if (whoami.isError) {
    setAccessToken(null)
    return <Navigate to={PATHS.SIGN_IN} state={{ from: location.pathname }} replace />
  }

  const authenticated = isWhoamiAuthenticated(whoami) || Boolean(getAccessToken())

  if (!authenticated) {
    return <Navigate to={PATHS.SIGN_IN} state={{ from: location.pathname }} replace />
  }

  return children
}
